<div class="liste-reservations">
	<p-accordion styleClass="liste-reservations-accordion">
		<p-accordionTab iconPos="end"
		                [(selected)]="panelReservationsOuvert">
			<ng-template pTemplate="header">
				<div class="liste-reservations-header">
					{{ 'GESTION_NAVETTE.TRAJETS.DETAIL_TRAJET.RESERVATIONS.VOIR_RESERVATIONS' | translate }}
				</div>
			</ng-template>
			<div class="liste-reservations-utilisateurs">
				@if (enChargement()) {
					<p-progressSpinner></p-progressSpinner>
				} @else {
					@for (reservation of reservations(); track reservation) {
						<app-ligne-reservation-trajet [reservation]="reservation"></app-ligne-reservation-trajet>
					} @empty {
						{{ 'GESTION_NAVETTE.TRAJETS.DETAIL_TRAJET.RESERVATIONS.AUCUNE_RESERVATION' | translate }}
					}
				}
			</div>
		</p-accordionTab>
	</p-accordion>
</div>